export default "__VITE_ASSET__D4hKw1wu__"